/**
 * AUTO-GENERATED by scripts/generate-cvent-plan.mjs — DO NOT EDIT BY HAND.
 *
 * Source of truth: src/analytics/cvent/actions/*.json.
 * Regenerate with: pnpm attendee-activities:generate-plan
 */
import { canPublish, isEnabled as isCventAnalyticsEnabled, track, type CventActivitiesBaseProperties } from './core';
import { QuestionAsked, type QuestionAskedProps } from './models';

export interface GeneratedTrackMethodDeps {
  isAttendee: () => boolean;
  collectBaseProperties: () => CventActivitiesBaseProperties;
  initialize: () => void;
}

export interface GeneratedTrackMethods {
  trackQuestionAsked: (payload: Omit<QuestionAskedProps, 'objectId'>) => boolean;
}

export const GENERATED_TRACK_METHODS_BY_ACTIVITY_TYPE = {
  'session.question_asked': 'trackQuestionAsked'
} as const;

export function createGeneratedTrackMethods(deps: GeneratedTrackMethodDeps): GeneratedTrackMethods {
  function trackQuestionAsked(payload: Omit<QuestionAskedProps, 'objectId'>): boolean {
    if (!deps.isAttendee()) {
      return false;
    }

    const baseProps = deps.collectBaseProperties();
    if (!canPublish(baseProps)) {
      return false;
    }

    if (!isCventAnalyticsEnabled()) {
      deps.initialize();
      if (!isCventAnalyticsEnabled()) {
        return false;
      }
    }

    const objectId = payload.sessionId;
    if (!objectId) {
      return false;
    }

    track(
      new QuestionAsked({
        objectId,
        ...payload
      })
    );

    return true;
  }

  return {
    trackQuestionAsked
  };
}
